var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn day-night"},[_c('b-form-checkbox',{attrs:{"switch":"","size":"lg"},model:{value:(_vm.darkMode),callback:function ($$v) {_vm.darkMode=$$v},expression:"darkMode"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }